import React from 'react';
import PropTypes from 'prop-types';
import PieChart from '../../Components/Charts/PieChart';
import EmptyVisualization from '../../Components/EmptyVisualization';
import Loading from '../../Components/Loading';

const StatesPieChart = ({ chartData, handleRetry }) => {
  const pieChartIsLoading = chartData.loading || !chartData.firstLoadComplete;
  const pieChartIsEmpty = !chartData.loading && chartData.dataIsEmpty;
  const pieChartHasError = !!chartData.error;

  return (
    <React.Fragment>
      { pieChartIsLoading && <Loading /> }

      { (pieChartIsEmpty || pieChartHasError) &&
        <div>
          <EmptyVisualization
            isError={pieChartHasError}
            handleRetry={handleRetry}
          >
            <PieChart visualizationData={chartData.visualizationData} />
          </EmptyVisualization>
        </div>
      }

      {!pieChartIsLoading && !pieChartIsEmpty && !pieChartHasError &&
        <PieChart visualizationData={chartData.visualizationData} />
      }
    </React.Fragment>
  );
};

StatesPieChart.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  handleRetry: PropTypes.func.isRequired,
};

export default React.memo(StatesPieChart);



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/StatesPieChart.js